import { render } from "./fotito2_ingles.vue?vue&type=template&id=107e2b6c&scoped=true"
import script from "./fotito2_ingles.vue?vue&type=script&lang=js"
export * from "./fotito2_ingles.vue?vue&type=script&lang=js"

import "./fotito2_ingles.vue?vue&type=style&index=0&id=107e2b6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-107e2b6c"]])

export default __exports__